import { computed } from 'mobx'
import { useMemo } from 'react'

export function useComputed<T>(func: () => T, deps?: any[]): T {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const ret = useMemo(() => computed(func), deps ?? [])
  return ret.get()
}
